import gql from 'graphql-tag';


const MUTATION_REMOVE_STORE_LOGO = gql`
	mutation RemoveStoreLogo($storeID: String!) {
		removeStoreLogo(storeID: $storeID)
	}
`;

export default MUTATION_REMOVE_STORE_LOGO;